/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { NavLink as RouterLink, matchPath, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, List, ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import BetaChip from 'src/components/application/BetaChip';
import NewChip from 'src/components/application/NewChip';
import ComingSoonChip from 'src/components/application/ComingSoonChip';
import FlatIcon, { FlatIconOptions } from 'src/components/ui/FlatIcon';

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px !important',
  },
  link: {
    justifyContent: 'flex-start',
    letterSpacing: 0,
    backgroundColor: 'blue',
    textTransform: 'none !important',
    color: `${theme.palette.weesu.dark_blue} !important`,
    width: '100%',
    height: 40,
    '& svg': {
      marginRight: '8px',
    },
  },
  subLink: {
    color: theme.palette.text.primary,
    marginLeft: '4px',
    position: 'relative',

    '&:hover': {
      color: `${theme.palette.weesu.light_blue} !important`,
    },

    '&::before': {
      content: '""',

      position: 'absolute',
      top: '14px',
      left: '0px',
      width: '10px',
      height: '1px',
      background: theme.palette.primary.main,
    },
  },
  linkActive: {
    marginLeft: '1px !important',
    color: `${theme.palette.weesu.light_blue} !important`,
    borderLeft: `4px solid ${theme.palette.weesu.dark_blue} !important`,
  },
  subLinkActive: {
    color: theme.palette.weesu.light_blue,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '15px',
      left: '-1px',
      width: '10px',
      height: '1px',
      background: theme.palette.weesu.light_blue,
    },
  },
  subLinkComingSoon: {
    color: theme.palette.neutral[300],
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '15px',
      left: '-1px',
      width: '10px',
      height: '1px',
      background: theme.palette.neutral[300],
    },
  },
  dropdownButton: {
    position: 'relative',
    '&::before': {
      content: '""',

      position: 'absolute',
      top: '0',
      left: '2px',
      width: '2px',
      height: 'calc(100% - 20px)',
      background: theme.palette.primary.main,
    },
  },
  betaChip: {
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.weesu.light_blue} !important`,
    border: `1px solid ${theme.palette.weesu.light_blue} !important`,
    marginLeft: '5px !important',
  },
  newChip: {
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.weesu.light_green} !important`,
    border: `1px solid ${theme.palette.weesu.light_green} !important`,
    marginLeft: '5px !important',
  },
}));

const NavItem = ({
  disabled,
  href,
  icon: Icon,
  title,
  subitems = [],
  subitemsVisible = '',
  setSubitemsVisible = () => {},
  subSubitemsVisible = '',
  setSubSubitemsVisible = () => {},
  selectedSubItem = '',
  setSelectedSubItem = () => {},
  selectedSubSubItem = '',
  setSelectedSubSubItem = () => {},
  mirrorTheIcon = false,
  beta = false,
  newer = false,
  comingSoon = false,
  ...rest
}) => {
  const location = useLocation();

  const active =
    href ?
      !!matchPath(
        {
          path: href,
          end: false,
        },
        location.pathname
      )
    : false;

  const handleToggleChildren = (item) => {
    if (item !== subitemsVisible) {
      setSubitemsVisible(item);
    } else {
      setSubitemsVisible(null);
    }
  };

  const handleToggleSubChildren = (item) => {
    if (item !== subSubitemsVisible) {
      setSubSubitemsVisible(item);
    } else {
      setSubSubitemsVisible(null);
    }
  };

  const handleSelectSubItem = (item, position) => setSelectedSubItem(item);
  const handleSelectSubSubItem = (item, position) => setSelectedSubSubItem(item);

  const classes = useStyles();

  return (
    <ListItem
      className={clsx(
        classes.item,
        subitemsVisible === title && classes.dropdownButton,
        comingSoon && classes.subLinkComingSoon
      )}
      //disabled={disabled}
      disablegutters='true'
      {...rest}>
      {subitems.length ?
        <>
          <Button
            className={clsx(classes.link, subitemsVisible === title && classes.linkActive)}
            onClick={() => {
              if (!disabled && !comingSoon) handleToggleChildren(title);
            }}>
            <FlatIcon
              icon={Icon}
              size='22px'
              invertHorizontally={mirrorTheIcon}
            />
            <span>{title}</span>
            {beta && <BetaChip />}
            {newer && <NewChip />}
            {comingSoon && <ComingSoonChip />}
            <Box marginLeft='auto'>
              {subitemsVisible === title ?
                <FlatIcon
                  icon={FlatIconOptions.collapse}
                  style={{ paddingTop: 5 }}
                />
              : <FlatIcon
                  icon={FlatIconOptions.expand}
                  style={{ paddingTop: 5 }}
                />
              }
            </Box>
          </Button>
          {subitems.map((item) => (
            <Collapse
              in={subitemsVisible === title ? true : false}
              key={item.title}
              timeout='auto'
              unmountOnExit
              sx={{ width: '100%' }}>
              {item.subitems && Array.isArray(item.subitems) && item.subitems.length ?
                <>
                  <Button
                    className={clsx(
                      classes.link,
                      subSubitemsVisible === item.title && classes.linkActive,
                      comingSoon && classes.subLinkComingSoon
                    )}
                    onClick={() => {
                      if (!disabled && !comingSoon) handleToggleSubChildren(item.title);
                    }}>
                    <FlatIcon
                      icon={item.icon}
                      style={{
                        marginLeft: subSubitemsVisible === item.title && classes.linkActive ? 5 : 10,
                      }}
                    />
                    <span>{item.title}</span>
                    {item.beta && <BetaChip />}
                    {item.newer && <NewChip />}
                    {item.comingSoon && <ComingSoonChip />}
                    <Box marginLeft='auto'>
                      {subSubitemsVisible === item.title ?
                        <FlatIcon
                          icon={FlatIconOptions.collapse}
                          style={{ paddingTop: 5 }}
                        />
                      : <FlatIcon
                          icon={FlatIconOptions.expand}
                          style={{ paddingTop: 5 }}
                        />
                      }
                    </Box>
                  </Button>
                  {item.subitems.map((subItem) => (
                    <>
                      <Collapse
                        in={subSubitemsVisible === subItem.title ? true : false}
                        key={subItem.title}
                        timeout='auto'
                        unmountOnExit
                        sx={{ width: '100%' }}>
                        <List
                          component='div'
                          disablegutters='true'
                          sx={{ paddingBottom: '10px' }}>
                          <ListItem
                            sx={{ height: 25, width: '98%' }}
                            className={clsx(
                              !subItem.disabled && classes.subLink,
                              selectedSubSubItem === subItem.title && !subItem.disabled && classes.subLinkActive,
                              comingSoon && classes.subLinkComingSoon
                            )}
                            component={RouterLink}
                            to={subItem.href}
                            onClick={() => {
                              if (!disabled && !comingSoon) handleSelectSubSubItem(subItem.title);
                            }}>
                            <FlatIcon
                              icon={FlatIconOptions.menuSubItem}
                              size='20'
                              style={{ marginLeft: 12 }}
                            />
                            <span style={{ marginLeft: 5, fontSize: 14 }}>{subItem.description}</span>
                            {subItem.beta && <BetaChip />}
                            {subItem.newer && <NewChip />}
                            {subItem.comingSoon && <ComingSoonChip />}
                          </ListItem>
                        </List>
                      </Collapse>
                    </>
                  ))}
                </>
              : <List
                  component='div'
                  disablegutters='true'
                  sx={{ paddingBottom: '10px' }}>
                  <ListItem
                    sx={{ height: 25, width: '98%' }}
                    className={clsx(
                      !item.disabled && !item.comingSoon && classes.subLink,
                      selectedSubItem === item.title && !item.disabled && classes.subLinkActive,
                      item.comingSoon && classes.subLinkComingSoon
                    )}
                    component={RouterLink}
                    to={item.comingSoon ? '#' : item.href}
                    onClick={() => {
                      if (!disabled && !comingSoon) handleSelectSubItem(item.title);
                    }}>
                    <FlatIcon
                      icon={FlatIconOptions.menuSubItem}
                      size='20'
                    />
                    <span style={{ marginLeft: 5, fontSize: 14 }}>{item.title}</span>
                    {item.beta && <BetaChip />}
                    {item.newer && <NewChip />}
                    {item.comingSoon && <ComingSoonChip />}
                  </ListItem>
                </List>
              }
            </Collapse>
          ))}
        </>
      : <Button
          component={RouterLink}
          className={clsx(classes.link, active && classes.linkActive, comingSoon && classes.subLinkComingSoon)}
          to={href}>
          {Icon && (
            <FlatIcon
              icon={Icon}
              size='22px'
              invertHorizontally={mirrorTheIcon}
            />
          )}
          <span style={{ marginRight: 'auto' }}>{title}</span>
          {beta && <BetaChip />}
          {newer && <NewChip />}
          {comingSoon && <ComingSoonChip />}
        </Button>
      }
    </ListItem>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavItem;
